import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from './history';
import loginReducer from '../../features/login/Store';
import listaProvaReducer from '../../features/listaDeProvas/Store';
import manualReducer from '../../features/manual/Store';
import notificacaoReducer from '../../features/notificacao/Store';
import breadcrumbReducer from '../../features/header/Store';
import accuracyRateReducer from '../../features/accuracyRate/Store';

/*
importar reducers a serem utilizados
*/

export default combineReducers({
  router: connectRouter(history),
  login: loginReducer,
  notificacao: notificacaoReducer,
  listaProva: listaProvaReducer,
  manual: manualReducer,
  breadcrumb: breadcrumbReducer,
  accuracyRate: accuracyRateReducer,
  /*
  exportar reducers
  */
});
